module.exports = __webpack_public_path__ + "img/12.c21b7cdb.jpg";